export default class ErrorSerializer {

    override(delegate) {
        if (this.delegate) {
            this.delegate.override(delegate)
        } else {
            this.delegate = delegate
        }
    }

    serialize(context, error) {
        if (this.delegate) {
            return Promise.resolve(this.delegate.serialize(context, error)).then((result) => {
                if (result !== undefined) {
                    return result
                }
                return this.customSerialize(context, error)
            })
        }
        return this.customSerialize(context, error)
    }

    customSerialize(context, error) {
        return this.makeErrorData(context, error)
    }

    makeErrorData(context, error) {
        const errorData = {
            type: 'Error',
            name: error.name,
            message: error.message,
            messages: [],
            namespace: this.getNamespace(context, error)
        }
        if (error.reactCatchInfo) {
            if (error.reactCatchInfo.componentStack) {
                errorData.messages.unshift(error.reactCatchInfo.componentStack)
            }
        }
        return errorData
    }

    // eslint-disable-next-line class-methods-use-this
    getNamespace(context, error) {
        if (error.namespace) {
            return error.namespace
        }
        if (context.namespace) {
            return context.namespace
        }
        if (context.t && context.t.ns) {
            // Get it from a property of the translation function
            return context.t.ns
        }
        return undefined
    }
}
